import { useLoggedOut } from "@/components/user-context";

import { SignupDefault } from "../components";

import { LoggedOut } from "./logged-out";

export const CompassSignup = () => {
    const loggedOut = useLoggedOut();

    if (loggedOut) {
        return <LoggedOut />;
    }

    return <SignupDefault />;
};
